import React from 'react'

import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'

const NotFound = () => {
  return (
    <Grid
      container
      sx={{
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Grid item xs={12}>
        <Typography variant='h1'>Page Not Found</Typography>
      </Grid>
      <Grid item xs={12}>
        <Link href='/' sx={{ cursor: 'pointer', textAlign: 'center' }}>
          <HomeOutlinedIcon sx={{ fontSize: 200 }} />
          <p>Return Home</p>
        </Link>
      </Grid>
    </Grid>
  )
}

export default NotFound
